import React from 'react'

const BlogPage = () => {
  return (
    <div className="container">
        <h1>Blog</h1>
        <p>現在工事中です！</p>
    </div>
  )
}

export default BlogPage